<template>
    <div class="tabs__content-helper">
        Reddit
    </div>
</template>
